













































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import Hamburger from '@/components/Hamburger/index.vue'
import { alterPassword } from '@/pages/base/api/api'
import { ElForm } from 'element-ui/types/form'
import { getUser, setApply, getApply } from '@/utils/cookies'
import { getAllList } from '@/pages/adhibition/api/index'
import moreDialog from '@/pages/adhibition/components/moreList.vue'
import { themeData } from '@/utils/data'
@Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger,
    moreDialog
  }
})
export default class extends Vue {
  private userData={}
  private isVisible =false
  private isDisable = false
  private userInfo = {}
  private dataTable =[]
  private isMoreVisible= false
  private chalk = ''
  private version = require('element-ui/package.json').version
  private formRules = {
    oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
    password: [{ required: true, message: '请输入新密码', trigger: 'blur' }]
  }
  get sidebar() {
    return AppModule.sidebar
  }
  // 获取用户
  get user() {
    return getUser() ? JSON.parse(getUser() as any) : null
  }
  get projectname() {
    return getApply() ? JSON.parse(getApply() as any).name : ''
  }

  get themeVal() {
    return this.$store.state.themeColor
  }

  @Watch('themeVal')
  themeValChange(val:any, oldVal:any) {
    this.updateTheme(val, oldVal)
  }
  created() {
   // 加载应用列表
   this.getList()
   // 初始化应用和平台
   this.initPlatform()
  }

  /// // 功能函数 /////
  // 初始化应用和平台
  private initPlatform() {
    // 管理员默认平台
   if (this.user.id < 10 && !getApply()) {
     setApply(JSON.stringify({ 'id': '1', 'createTime': null, 'createUser': null, 'updateTime': null, 'updateUser': null, 'name': '应用选择', 'abbreviation': '权限管家', 'status': null, 'describe': null }))
     this.$store.commit('updatedTheme', '')
     this.$store.commit('updatedThemeColor', '#409EFF')
   } else {
     // 应用选择相应主题
     let platform = getApply() ? JSON.parse(getApply() as any) : null
     if (platform && platform.name !== '应用选择') {
       const theme = platform.color ? platform.color : 'default'
       const color = (themeData.find(item => item.value === theme) as any).color
       this.$store.commit('updatedTheme', theme)
       this.$store.commit('updatedThemeColor', color)
     }
   }
  }
  // 控制左侧菜单
  private toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }
  // 退出
  private logout(command:string) {
    if (command === '1') {
      this.$confirm('', '确认退出系统?', {
          confirmButtonText: '确定',
          type: 'warning'
        }).then(async() => {
          await UserModule.LogOut()
          // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
          this.$router.replace('/login')
        })
    } else if (command === '0') {
      this.isVisible = true
    } else if (command === '2') {
      // 切换到平台管理
      setApply(JSON.stringify({ 'id': '1', 'createTime': null, 'createUser': null, 'updateTime': null, 'updateUser': null, 'name': '应用选择', 'abbreviation': '权限管家', 'status': null, 'describe': null }))
      location.reload()
    }
  }
  // 修改密码
  handleSubmit() {
    this.isDisable = true
    let userData = this.userData as any
    // setTimeout(() => {
    //   this.isDisable = false // 点击一次时隔两秒后才能再次点击
    // }, 2000)
    userData.id = this.user.id
    if (userData.confirmPassword !== userData.password) {
      this.$message({
        message: '两次密码不一致',
        type: 'error'
      })
      return false
    }
    (this.$refs.ruleForm as ElForm).validate(async(valid: boolean) => {
      if (valid) {
        const { data } = await alterPassword(this.userData)
        this.isDisable = false
        if (data.isSuccess) {
          this.isVisible = false;
          (this.$refs.ruleForm as ElForm).resetFields()
          this.$message({
            message: '设置成功！',
            type: 'success'
          })
          this.handleClose()
        } else {
          // this.$message({
          //   message: data.msg,
          //   type: 'error'
          // })
        }
      } else {
        return false
      }
    })
  }
  // 获取数据
  private async getList() {
    const { data } = await getAllList({})
    if (data.isSuccess === true) {
      this.dataTable = data.data
      if (this.user.id >= 10 && !getApply()) {
        setApply(JSON.stringify(this.dataTable[0]))
      }
    }
  }
  handleClose() {
    this.isVisible = false
    ;(this.$refs.ruleForm as ElForm).resetFields()
  }
  handleMoreClose() {
    this.isMoreVisible = false
  }
  // 应用筛选
  handleName(val:any) {
    if (val !== 0) {
      setApply(JSON.stringify(val))
      location.reload()
    } else {
      this.isMoreVisible = true
    }
  }

  // 变更主题色
  updateTheme(val:any, oldVal:any) {
    if (typeof val !== 'string') return
    const head = document.getElementsByTagName('head')[0]
    const themeCluster = this.getThemeCluster(val.replace('#', ''))
    const getHandler = (variable:any, id:any) => {
      return () => {
        const originalCluster = this.getThemeCluster(
          oldVal.replace('#', '')
        )
        const newStyle = this.updateStyle(
          this.chalk,
          originalCluster,
          themeCluster
        )

        let styleTag = document.getElementById(id)
        if (!styleTag) {
          styleTag = document.createElement('style')
          styleTag.setAttribute('id', id)
          head.appendChild(styleTag)
        }
        styleTag.innerText = newStyle
      }
    }
    const chalkHandler = getHandler('chalk', 'chalk-style')
    if (!this.chalk) {
      const url = `https://unpkg.com/element-ui@${this.version}/lib/theme-chalk/index.css`
      this.getCSSString(url, chalkHandler, 'chalk')
    } else {
      chalkHandler()
    }
  }

  updateStyle(style:any, oldCluster:any, newCluster:any) {
    let newStyle = style
    oldCluster.forEach((color:any, index:any) => {
      newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index])
    })
    return newStyle
  }

  // 获取相应主题
  getCSSString(url:any, callback:any, variable:any) {
    const xhr = new XMLHttpRequest()
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        if (variable) {
          this.chalk = xhr.responseText.replace(/@font-face{[^}]+}/, '')
        }
        callback(xhr.responseText)
      }
    }
    xhr.open('GET', url)
    xhr.send()
  }

  // 获取相关主题所有颜色
  private getThemeCluster(theme: String) {
    const tintColor = (color: any, tint: any) => {
      let red = parseInt(color.slice(0, 2), 16)
      let green = parseInt(color.slice(2, 4), 16)
      let blue = parseInt(color.slice(4, 6), 16)

      if (tint === 0) {
        // when primary color is in its rgb space
        return [red, green, blue].join(',')
      } else {
        red += Math.round(tint * (255 - red))
        green += Math.round(tint * (255 - green))
        blue += Math.round(tint * (255 - blue))

        const newRed = red.toString(16)
        const newGreen = green.toString(16)
        const newBlue = blue.toString(16)

        return `#${newRed}${newGreen}${newBlue}`
      }
    }

    const shadeColor = (color: any, shade: any) => {
      let red = parseInt(color.slice(0, 2), 16)
      let green = parseInt(color.slice(2, 4), 16)
      let blue = parseInt(color.slice(4, 6), 16)

      red = Math.round((1 - shade) * red)
      green = Math.round((1 - shade) * green)
      blue = Math.round((1 - shade) * blue)

      const newRed = red.toString(16)
      const newGreen = green.toString(16)
      const newBlue = blue.toString(16)

      return `#${newRed}${newGreen}${newBlue}`
    }

    const clusters = [theme]
    for (let i = 0; i <= 9; i++) {
      clusters.push(tintColor(theme, Number((i / 10).toFixed(2))))
    }
    clusters.push(shadeColor(theme, 0.1))
    return clusters
  }
}

